import type {
  ConvertibleUnit,
  FormatOptions,
  Unit,
} from '@dynatrace-sdk/units';

import type { Formatter } from '../../core/types/formatter.js';
import type {
  MaxScaleBoundary,
  MinScaleBoundary,
} from '../../core/types/min-max-config.js';
import type { AxisScaleType } from '../../core/types/scales.js';

/**
 * Defines which position to apply to the axis
 * @public
 */
export type YAxisPosition = 'left' | 'right';

/**
 * Props for the TimeseriesChart.YAxis slot component props
 * @public
 */
export interface TimeseriesChartYAxisProps {
  /**
   * Maximal value on the y-axis.
   * @defaultValue 'auto'
   */
  max?: MaxScaleBoundary;
  /**
   * Minimal value on the y-axis.
   * @defaultValue 'auto'
   */
  min?: MinScaleBoundary;
  /** The position of the Y-axis relative to the chart area. */
  position?: YAxisPosition;
  /** The label to display alongside the axis. */
  label?: string;
  /** The scale of the Y axis values. */
  scale?: AxisScaleType;
  /** Timeseries tick formatter */
  formatter?: Formatter | FormatOptions<Unit, ConvertibleUnit>;
}

/**
 * @public
 */
export const YAxis = (props: TimeseriesChartYAxisProps) => null;

YAxis['displayName'] = 'TimeseriesChart.YAxis';
